import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BioComponent } from 'src/app/view/labs/bio/bio.component';
import { ChemistryComponent } from 'src/app/view/labs/chemistry/chemistry.component';
import { ComputerComponent } from 'src/app/view/labs/computer/computer.component';
import { FineComponent } from 'src/app/view/labs/fine/fine.component';
import { LabsComponent } from 'src/app/view/labs/labs.component';
import { PhysicsComponent } from 'src/app/view/labs/physics/physics.component';
import { SelfComponent } from 'src/app/view/labs/self/self.component';
import { RouterModule } from '@angular/router';
import { OverviewComponent } from 'src/app/view/labs/overview/overview.component';
import { MathComponent } from 'src/app/view/labs/math/math.component';



@NgModule({
  declarations: [
    LabsComponent,
    PhysicsComponent,
    ChemistryComponent,
    BioComponent,
    SelfComponent,
    ComputerComponent,
    FineComponent,
    OverviewComponent,
    MathComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {path:'',component:LabsComponent,children:[
        {path:'physics',component:PhysicsComponent},
        {path:'chemistry',component:ChemistryComponent},
        {path:'biology',component:BioComponent},
        {path:'self-management',component:SelfComponent},
        {path:'computer',component:ComputerComponent},
        {path:'fine',component:FineComponent},
        {path:'overview',component:OverviewComponent},
        {path:'math',component:MathComponent}
      ]}
    ])
  ]
})
export class LabsModule { }
